/**
 * Created by daniesy on 09/11/2016.
 */
require("babel-polyfill");
const d3 = require('d3');

import Data from './data.js';
import PopupData from './popupData.js';
import ChartData from './chartData.js';
import Chart from './chart.js';
import Alert from './alert.js';

class Widget {
    constructor(options = {}) {
        this.cachedWidth = window.innerWidth;

        this.element = options.element || "#wizard";
        this.d3Element = d3.select(this.element);

        this.isMobile = this.detectmob();

        this.width = options.width || this.decideWidth();
        this.height = options.height || this.decideHeight();

        this.margins = options.margins || { top: 25, right: 0, bottom: 25, left: 25 };

        this.animationSpeed = options.animationSpeed || 7000;

        this.dataCsv = options.dataCsv || "data.csv";
        this.questionsCsv = options.questionsCsv || "questions.csv";

        this.popupData = {};
        this.chartData = [];
        this.loadingRemaining = 2;
        this.index = 0;
        this.correct = 0;
        this.init();

        this.d3Element.attr("style", `height: ${this.height}px`);

        this.detectResize(options);
    }

    detectResize(options) {
      let timeout = false,
          delta = 300;

        window.addEventListener('resize', (event) => {
          if (timeout === false) {
              timeout = true;
              setTimeout(() => {
                timeout = false;
                this.reset(options);
              }, delta);
          }
        });
    }

    reset(options) {
        if(window.innerWidth === this.cachedWidth) {
          return;
        }
        this.cachedWidth = window.innerWidth;

        this.width = options.width || this.decideWidth();
        this.height = options.height || this.decideHeight();
        this.index = 0;
        this.correct = 0;
        this.d3Element.attr('style', "").html("");
        this.run();
    }

    detectmob() {
        return !!(navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i));
    }

    decideWidth() {
        if(this.isMobile || window.innerWidth < 500) {
            return window.innerWidth
        }

        return this.d3Element.node().getBoundingClientRect().width;
    }

    decideHeight() {
        if(this.isMobile || window.innerWidth < 500) {
            return window.innerHeight;
        }

        return this.d3Element.node().getBoundingClientRect().height;
    }

    init() {
        this.loadQuestions();
        this.loadChartData();
        if(this.isMobile) {
          this.d3Element.classed("widget--mobile", true);
        }
    }

    loadQuestions() {
        new Data(this.questionsCsv, data => {
            this.popupData = new PopupData(data);
            this.finishedLoading();
        });
    }

    loadChartData() {
        new Data(this.dataCsv, data => {
            this.chartData = new ChartData(data);
            this.finishedLoading();
        });
    }

    finishedLoading() {
        if (--this.loadingRemaining === 0) {
            this.run();
        }
    }

    run() {
        this.drawStartAlert();
    }

    drawStartAlert() {
        let alert = new Alert('How have CTAs performed over the past 30 years?', 'Almost any investor is searching for instruments that are able to deliver performance during turbulent periods. Systematic traders, also known as CTA or managed futures, are commonly accepted as good diversifiers in times of crisis. But have they really outperformed equities in every market correction?', 'Start', (target) => {
           target.hide();
           this.drawMainChart();
           this.drawSource();
        });
        alert.drawInElement(this.d3Element);
        alert.show(400);
    }

    drawMainChart() {
        let chart = new Chart({
            element: this.element,
            width: this.width,
            height: this.height - 30,
            margins: this.margins,
            dateFormat: '%Y'
        });
        chart.addLine(this.chartData.spx, 'S&P 500 Total Return', 'spx')
             .addLine(this.chartData.cta, 'CTA Index', 'cta')
             .draw()
             .drawEvents(this.chartData.events);

        chart.animateToDate(this.popupData.animationStepAtIndex(this.index), this.animationSpeed)
             .then(() => this.presentQuestion(chart));
    }

    drawSource() {
      d3.select(this.element)
      .append('small')
      .attr('class', 'source')
      .text('Source: UBS, Bloomberg, HFR, Google, as of 2016/12.')
    }

    presentQuestion(chart) {
        chart.toggleBlurred();
        chart.pauseEvents();
        let that = this;
        let question = this.popupData.questionAtIndex(this.index);
        question.drawInElement(this.d3Element);
        question.onFinished = function (correct) {
            if (correct) {
                that.correct++;
            }
            chart.toggleBlurred();
            chart.resumeEvents();
            that.index++;
            if (!that.popupData.lastQuestion(that.index)) {
            // if (that.popupData.lastQuestion(that.index)) {
                chart.animateToDate(that.popupData.animationStepAtIndex(that.index), that.animationSpeed).then(() => that.presentQuestion(chart));
            } else {
                chart.toggleFinished();
                chart.resetCourtain();
                chart.animate(that.animationSpeed * 2, true).then(() => that.presentConclusion(chart));
            }
        }
    }

    presentAnsweredQuestion(chart, correct, index) {
        chart.toggleBlurred();
        let question = this.popupData.questionAtIndex(index);
        question.drawInElementAnswered(this.d3Element, correct);
        question.onFinished = () => {
            chart.toggleBlurred();
        }
    }

    presentConclusion(chart) {
        let alert = new Alert(`${this.correct} out of 4 correct`, this.popupData.conclusion.text, 'Review the graph', (target) => {
                target.hide();
                chart.toggleBlurred();
                this.reviewGraph(chart)
            });
        alert.drawInElement(this.d3Element);
        alert.show(400);
        chart.toggleBlurred();
    }

    reviewGraph(chart) {
        chart.drawAnswers(this.popupData.getAnswers());
        chart.onAnswerClicked = (d, i) => {
            this.presentAnsweredQuestion(chart, d.correct, i);
        };

        let button = this.d3Element.append('button').attr("class", "button-restart").text("Restart").on("click", () => {
            this.index = 0;
            this.correct = 0;

            chart.resetEvents();
            chart.resetCourtain();
            chart.resumeEvents();
            chart.toggleFinished();
            chart.removeAnswers();

            chart.animateToDate(this.popupData.animationStepAtIndex(this.index), this.animationSpeed).then(() => this.presentQuestion(chart));

            button.remove();
        });
    }
}

module.exports = Widget;



// WEBPACK FOOTER //
// ./src/js/widget.js